/* BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
*/

(function () {
  'use strict';

  const EASE = 'power2.out';
  const ST_TOGGLE = 'play none none none';
  const START_FADE = 'top 88%';
  const START_STAGGER = 'top 84%';

  const TEFAT_MOTION = {
    durationReveal: 0.55,
    durationFooterItem: 0.28,
    staggerDefault: 0.08,
    staggerFooter: 0.04,
    yReveal: 22,
    yRevealMobile: 14,
  };

  var scrollRefreshBound = false;
  var lenisHealthTimer = null;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isAndroid() {
    return /Android/i.test(navigator.userAgent || '');
  }

  function isFinePointerDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function canUseLenis() {
    if (typeof Lenis === 'undefined') return false;
    if (prefersReducedMotion()) return false;
    if (isAndroid()) return false;
    if (!isFinePointerDesktop()) return false;
    return true;
  }

  function markNativeScroll() {
    var html = document.documentElement;
    html.dataset.scroll = 'native';
    html.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped', 'lenis-scrolling', 'lenis-autoToggle');
  }

  function pageScrollHeight() {
    return Math.max(
      document.documentElement.scrollHeight,
      document.body ? document.body.scrollHeight : 0
    );
  }

  function bindScrollRefresh() {
    if (scrollRefreshBound) return;
    scrollRefreshBound = true;
    window.addEventListener(
      'resize',
      function () {
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
      },
      { passive: true }
    );
  }

  function initScrollReveal(reduced) {
    const y = reduced ? 0 : isMobileViewport() ? TEFAT_MOTION.yRevealMobile : TEFAT_MOTION.yReveal;
    const dur = reduced ? 0.01 : TEFAT_MOTION.durationReveal;
    const ease = reduced ? 'none' : EASE;
    const stBase = {
      start: reduced ? 'top bottom' : START_FADE,
      toggleActions: ST_TOGGLE,
      invalidateOnRefresh: true,
    };

    gsap.utils.toArray('[data-animate="fade-in"]').forEach(function (el) {
      gsap.from(el, {
        autoAlpha: reduced ? 1 : 0,
        y: y,
        duration: dur,
        ease: ease,
        scrollTrigger: Object.assign({ trigger: el }, stBase),
      });
    });

    gsap.utils.toArray('[data-animate="stagger"]').forEach(function (container) {
      var items = container.querySelectorAll('[data-animate-item]');
      if (!items.length) return;
      var isFooter = container.classList.contains('tefat-footer');
      var itemDur = reduced ? 0.01 : isFooter ? TEFAT_MOTION.durationFooterItem : TEFAT_MOTION.durationReveal;
      var stagger = reduced ? 0 : isFooter ? TEFAT_MOTION.staggerFooter : TEFAT_MOTION.staggerDefault;
      gsap.from(items, {
        autoAlpha: reduced ? 1 : 0,
        y: y,
        duration: itemDur,
        stagger: stagger,
        ease: ease,
        scrollTrigger: Object.assign(
          {
            trigger: container,
            start: reduced ? 'top bottom' : START_STAGGER,
          },
          { toggleActions: ST_TOGGLE, invalidateOnRefresh: true }
        ),
      });
    });
  }

  function initNativeScrollReveal(reduced) {
    window.lenis = null;
    markNativeScroll();
    initScrollReveal(reduced);
    ScrollTrigger.refresh();
    bindScrollRefresh();
  }

  function destroyLenisToNative(lenis, tickerFn, reduced) {
    if (lenisHealthTimer) {
      clearTimeout(lenisHealthTimer);
      lenisHealthTimer = null;
    }

    try {
      if (tickerFn) gsap.ticker.remove(tickerFn);
    } catch (e) {}

    try {
      if (lenis && typeof lenis.destroy === 'function') lenis.destroy();
    } catch (e) {}

    window.lenis = null;
    markNativeScroll();

    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (st) {
        st.kill();
      });
    }

    initNativeScrollReveal(reduced);
  }

  function watchLenisHealth(lenis, tickerFn, reduced) {
    lenisHealthTimer = setTimeout(function () {
      var viewHeight = window.innerHeight || 0;
      var contentHeight = pageScrollHeight();
      var scrollable = contentHeight - viewHeight;

      if (scrollable < 80) return;

      var limit = typeof lenis.limit === 'number' ? lenis.limit : scrollable;
      if (limit < 1) {
        destroyLenisToNative(lenis, tickerFn, reduced);
        return;
      }

      var before = window.scrollY || document.documentElement.scrollTop || 0;
      var target = Math.min(Math.max(96, Math.floor(scrollable * 0.15)), scrollable);

      try {
        lenis.scrollTo(target, { immediate: true });
      } catch (e) {
        destroyLenisToNative(lenis, tickerFn, reduced);
        return;
      }

      requestAnimationFrame(function () {
        var after = window.scrollY || document.documentElement.scrollTop || lenis.scroll || 0;
        var moved = Math.abs(after - before) > 8 || Math.abs(after - target) < 48;

        try {
          lenis.scrollTo(before, { immediate: true });
        } catch (e) {}

        if (!moved) {
          destroyLenisToNative(lenis, tickerFn, reduced);
        }
      });
    }, 700);
  }

  function initLenisAndScrollTrigger() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      markNativeScroll();
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var reduced = prefersReducedMotion();

    if (!canUseLenis()) {
      initNativeScrollReveal(reduced);
      return;
    }

    var lenis = null;
    var tickerFn = null;

    try {
      lenis = new Lenis({
        autoRaf: false,
        lerp: 0.1,
        smoothWheel: true,
        syncTouch: false,
      });
      window.lenis = lenis;

      lenis.on('scroll', ScrollTrigger.update);

      tickerFn = function (time) {
        if (!window.lenis) return;
        window.lenis.raf(time * 1000);
      };
      gsap.ticker.add(tickerFn);
      gsap.ticker.lagSmoothing(0);

      initScrollReveal(false);
      ScrollTrigger.refresh();
      bindScrollRefresh();
      watchLenisHealth(lenis, tickerFn, reduced);
    } catch (e) {
      destroyLenisToNative(lenis, tickerFn, reduced);
    }
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        document.fonts.ready.then(initLenisAndScrollTrigger).catch(initLenisAndScrollTrigger);
      });
    } else {
      document.fonts.ready.then(initLenisAndScrollTrigger).catch(initLenisAndScrollTrigger);
    }
  }

  boot();
})();
